import React from "react";
import { getIsApplicationComplete } from "../../../services/Product/ProductService/productService";
import Grid from "@mui/material/Grid";
import { translate } from "../../../services/Translations/translatorService";
import _ from "lodash";
import ContentBox from "../../ContentBox/ContentBox";

import { ProductUnion } from "../../../types/ProductUnion";
import dayjs from "dayjs";

type PreleadInfoBoxProps = {
  product: ProductUnion;
};

const PreleadInfoBox = ({ product }: PreleadInfoBoxProps) => {
  if (!_.includes(["divorce", "settlement"], product.productClassName) || getIsApplicationComplete(product)) {
    return null;
  }

  return (
    <ContentBox headline="Angaben bei Registrierung">
      <Grid container spacing={2}>
        <Grid size={5}>
          {translate("customer.prelead.landingPage.label")}:
        </Grid>
        <Grid size={5}>
          {product.customer.prelead?.landingPage}
        </Grid>
        {product.productClassName === "divorce" && (
          <>
            <Grid size={5}>
              {translate("customer.prelead.classification.label")}:
            </Grid>
            <Grid size={5}>
              {product.customer.prelead?.classification &&
                translate("customer.prelead.classification.values." + product.customer.prelead.classification)}
            </Grid>
          </>
        )}
        {product.productClassName === "settlement" && (
          <>
            <Grid size={5}>
              {translate("customer.prelead.numberOfEmployees.label")}:
            </Grid>
            <Grid size={5}>
              {product.customer.prelead?.numberOfEmployees &&
                translate("customer.prelead.numberOfEmployees.values." + product.customer.prelead.numberOfEmployees)}
            </Grid>
            <Grid size={5}>
              {translate("customer.prelead.employedSince.label")}:
            </Grid>
            <Grid size={5}>
              {product.customer.prelead?.employedSince &&
                dayjs(product.customer.prelead.employedSince).format("MM/YYYY")}
            </Grid>
            <Grid size={5}>
              {translate("customer.prelead.grossSalary.label")}:
            </Grid>
            <Grid size={5}>
              {product.customer.prelead?.grossSalary && `${product.customer.prelead.grossSalary} €`}
            </Grid>
          </>
        )}
      </Grid>
    </ContentBox>
  );
};

export default PreleadInfoBox;
